const fr: Record<string, string> = {
  'bookmarks.empty':
    "Aucun favori pour le moment. Parcourez les pages et cliquez sur l'icône de favori pour les enregistrer ici.",
  'bookmarks.add': 'Ajouter aux favoris',
  'bookmarks.remove': 'Retirer des favoris',
  'bookmarks.moveUp': 'Monter',
  'bookmarks.moveDown': 'Descendre',
  'bookmarks.open': 'Ouvrir la page',
  'bookmarks.edit.open': 'favori',
  'bookmarks.edit.title': 'Modifier le favori',
  'bookmarks.edit.name': 'Nom',
  'bookmarks.edit.description': 'Description',
  'bookmarks.edit.color': 'Couleur',
  'bookmarks.configure': 'Configurer',
  'bookmarks.configuring': 'Terminé',
  'bookmarks.archive': 'Archiver',
};

export default fr;
